import React from 'react';
import { Box, Typography, Card, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BlueLocation } from './Marketplaceicons';

// --- Styled Components (Co-located at the bottom) ---

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  display: 'grid',
  gap: '20px',
  marginTop: isMobile ? '50px' : '100px',
}));

const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  fontFamily: 'Poppins',
  fontWeight: 500,
  color: '#112347',
  fontSize: isMobile ? '20px' : '24px',
}));

const AddressContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: '20px',
});

const AddressText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  fontFamily: 'Poppins !important',
  color: '#666666',
  fontSize: isMobile ? '16px' : '24px',
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
}));

const ItemContainer = styled(Box)({
  display: 'flex',
  height: '85px',
  marginTop: '25px',
  gap: '20px',
  padding: '0 6px',
});

const ScoreCard = styled(Card)({
  width: '85px',
  height: '84px',
  background: '#FFFFFF',
  boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
  borderRadius: '8px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const ScoreValue = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '32px',
  color: '#6C2AD2',
});

const ScoreLabel = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  color: '#666666',
});

const InfoBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

const ItemTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  fontFamily: 'Poppins',
  fontWeight: 500,
  color: '#112347',
  fontSize: isMobile ? '20px' : '24px',
}));

const ItemSubtitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  color: '#666666',
  fontSize: isMobile ? '16px' : '20px',
}));

const Validationerror = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  color: '#666666',
  fontSize: isMobile ? '16px' : '20px',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '10px',
}));

// --- Main Component ---

const WalkScore = ({ walkScore, address, isMobile }) => {
  return (
    <Container isMobile={isMobile}>
      <Title isMobile={isMobile}>Walk Score</Title>
      {walkScore?.length > 0 ? (
        <>
          <AddressContainer>
            {/* Replace with your BlueLocation icon */}
            <AddressText isMobile={isMobile}>
              <BlueLocation />
              {address}
            </AddressText>
          </AddressContainer>

          {walkScore?.map((item, index) => (
            <ItemContainer key={item.id || index}>
              <ScoreCard>
                <Stack>
                  <ScoreValue>{item.score}</ScoreValue>
                </Stack>
                <Stack>
                  <ScoreLabel>{item.type}</ScoreLabel>
                </Stack>
              </ScoreCard>

              <InfoBox>
                <ItemTitle isMobile={isMobile}>{item.name}</ItemTitle>
                <ItemSubtitle isMobile={isMobile}>{item.distance}</ItemSubtitle>
              </InfoBox>
            </ItemContainer>
          ))}
        </>
      ) : (
        <Validationerror>
          No walkscore details saved for this property
        </Validationerror>
      )}
    </Container>
  );
};

export default WalkScore;
